﻿import React, { MouseEvent, useState } from 'react';
import { useImpersonatedCountryContext } from '../../HeadBar';
import Box from '@mui/material/Box';
import { Spacer } from '../../../Spacer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Language, TimeZone } from '../ProfileApi';
import { UserProfile } from '../models/profile';
import { ProfileContextLabels } from '../ProfileContext';
import TranslatedProfileContextMenu from './ProfileContextMenu';
import ImpersonationLabel from './ImpersonationLabel';
import ImpersonatedCountryFlag from './ImpersonatedCountryFlag';
import { useUserContext } from '../../../../../../../shared/context/user-context';

type ProfileContextLargerScreenProps = {
    availableLanguages: Language[];
    availableTimeZones: TimeZone[];
    userProfile: UserProfile;
    labels: ProfileContextLabels;
};

function ProfileContextLargerScreen({
    labels,
    userProfile,
    availableTimeZones,
    availableLanguages
}: ProfileContextLargerScreenProps) {
    let { user } = useUserContext();
    let [showMenu, setShowMenu] = useState<boolean>(false);
    let [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);

    let { impersonatedCountry } = useImpersonatedCountryContext();

    function handleClick(event: MouseEvent) {
        setAnchorElement(event.currentTarget);
        setShowMenu((state) => !state);
    }

    function handleMenuClose() {
        setShowMenu(false);
        setAnchorElement(null);
    }

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flex: '1 0 auto'
                }}
            >
                {user.details.isImpersonated ? (
                    <>
                        <ImpersonationLabel label={labels.loggedInAs} />
                        <Spacer />
                    </>
                ) : null}
                <IconButton
                    sx={{
                        color: '#fff',
                        flex: '1 0 auto'
                    }}
                    onClick={handleClick}
                >
                    {impersonatedCountry ? (
                        <ImpersonatedCountryFlag countryId={impersonatedCountry.id} />
                    ) : null}
                    <Typography
                        variant="body1"
                        sx={{
                            fontFamily: 'Gilroy-Regular',
                            fontSize: '12px'
                        }}
                    >
                        {user.details.isImpersonated ? user.details.name : userProfile.name}
                    </Typography>
                    {showMenu ? (
                        <>
                            <Spacer />
                            <ExpandLessIcon />
                        </>
                    ) : (
                        <>
                            <Spacer />
                            <ExpandMoreIcon />
                        </>
                    )}
                </IconButton>
            </Box>
            <TranslatedProfileContextMenu
                open={showMenu}
                onClose={handleMenuClose}
                anchorElement={anchorElement}
                availableLanguages={availableLanguages}
                availableTimeZones={availableTimeZones}
                userProfile={userProfile}
            />
        </>
    );
}

export default ProfileContextLargerScreen;
